import React from 'react'
import Toolbar from '@mui/material/Toolbar'
import { useStyles } from './SimpleHeader.styles'

export interface SimpleHeaderProps {
  logoUrl?: string
}

export const SimpleHeader: React.FC<SimpleHeaderProps> = ({ logoUrl }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      {logoUrl && (
        <div data-testid="simple-header">
          <CustomLogo url={logoUrl} />
        </div>
      )}
      {!logoUrl && <Toolbar></Toolbar>}
    </div>
  )
}

export interface LogoProps {
  url: string
}

export const CustomLogo: React.FC<LogoProps> = ({ url }) => {
  const { classes } = useStyles()
  return (
    <div data-testid="custom-logo">
      <img src={url} className={classes.logoImg} />
    </div>
  )
}
